import styled from "styled-components";

export const DashboardPageStyled = styled.div`

`;



